import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useId } from 'react';
import { FieldContextProvider } from './Input.js';
/**
 * Field — labeled form-field wrapper.
 *
 * The `<label>` is associated with its child input via a generated
 * id (`useId`), so the consuming app doesn't have to wire ids
 * manually. Pass the input as `children` — it should be a single
 * focusable control (e.g. `<Input>`).
 *
 * @example
 *   <Field label="Email" error={errors.email}>
 *     <Input type="email" name="email" />
 *   </Field>
 */
export const Field = forwardRef(function Field({ label, hint, error, required, className, children, ...rest }, ref) {
    // `useId` is stable across SSR + hydration. We pass the generated
    // id down to the child input via the Field's data attribute; the
    // Input reads it via React.cloneElement (see Input.tsx).
    const id = useId();
    const classes = ['osd-field', error ? 'osd-field--error' : null, className]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("div", { ref: ref, className: classes, "data-field-id": id, ...rest, children: [_jsxs("label", { className: "osd-field__label", htmlFor: id, children: [label, required ? (_jsxs("span", { "aria-hidden": "true", className: "osd-field__required", children: [' ', "*"] })) : null] }), _jsx(FieldContextProvider, { value: id, children: children }), hint && !error ? _jsx("p", { className: "osd-field__hint", children: hint }) : null, error ? (_jsx("p", { className: "osd-field__error", role: "alert", children: error })) : null] }));
});
//# sourceMappingURL=Field.js.map